import { useCallback } from 'react';
import { useAllSelectedFinanceModels } from '../useCustomerCatalogueService';
import { useRequiredFinanceModels } from '../useFinanceModels';

export const useValidateFinanceModels = () => {
  const requiredFinanceModels = useRequiredFinanceModels();
  const selectedModels = useAllSelectedFinanceModels();

  return useCallback<() => string>(() => {
    let errorMessage = '';

    const missingCategoryNames: string[] = [];
    requiredFinanceModels.forEach(requiredModel => {
      const selectedModel = selectedModels?.find(selectedModel => {
        let matchesRequired = true;

        if (requiredModel.categoryId && selectedModel.categoryId !== requiredModel.categoryId) {
          matchesRequired = false;
        }

        if (requiredModel.manufacturerId && selectedModel.manufacturerId !== requiredModel.manufacturerId) {
          matchesRequired = false;
        }

        return matchesRequired;
      });

      if (!selectedModel || !selectedModel.id) {
        const missingName = `${requiredModel.category.name}${
          requiredModel.manufacturer.name ? ` (${requiredModel.manufacturer.name})` : ''
        }`;

        if (!missingCategoryNames.includes(missingName)) missingCategoryNames.push(missingName);
      }
    });

    if (missingCategoryNames.length > 0) {
      errorMessage = `Each category and manufacturer must have a selected finance model.\n\nPlease ensure a finance model is selected for the following combination${
        missingCategoryNames.length > 1 ? 's' : ''
      }:\n\n - ${missingCategoryNames.join('\n - ')}`;
    }

    return errorMessage;
  }, [requiredFinanceModels, selectedModels]);
};
